import React from 'react';

const STEPS = [
    { t: 'Book a 30-min onboarding call', d: 'Mark walks you through the platform live with dummy data. No prep needed.' },
    { t: 'Free advisor account, instant', d: 'Full platform access, single dashboard, AdvisorMatch profile live to VCs.' },
    { t: 'Introduce your first client', d: "Use our one-pager and email template. Your client pays — you don't." },
    { t: 'Get found, grow', d: 'Your profile is promoted to unaffiliated companies and 40+ VCs.' },
];

const FractionalProcessSection = () => (
    <section id="process" className="lp-process">
        <div className="lp-container">
            <h2 className="lp-process-head" data-lp-reveal>How it works.</h2>
            <div className="lp-steps">
                <div className="lp-steps-line" aria-hidden="true" />
                {STEPS.map((s, i) => (
                    <div className="lp-step" key={i} data-lp-reveal data-lp-delay={i * 100}>
                        <div className="n">{i + 1}</div>
                        <div>
                            <h3>{s.t}</h3>
                            <p>{s.d}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default FractionalProcessSection;
